import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import ChevronRight from "@assets/svg/ChevronRight";
import getWalletIcon from "./WalletIcon";
import testIds from "@constants/testIds";

type TransactionCardProps = {
  item: {
    key: string;
    title: string;
    value: number;
    value_txt: string;
    nav_to: string;
    types: string[];
  };
  onPress: () => void;
};

const TransactionCard: React.FC<TransactionCardProps> = ({ item, onPress }) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={styles.transactionContainer}
      activeOpacity={0.7}
      testID={`${item.key}+${item?.title}`}
    >
      {getWalletIcon(item.key)}
      <View style={styles.transactionTextContainer}>
        <Text style={styles.transactionAmount}>{item?.value_txt}</Text>
        <Text variant="body_text_3" style={styles.transactionDescription}>
          {item?.title}
        </Text>
      </View>
      <View style={styles.chevron}>
        <ChevronRight pathFill={color.darkGrey} style={styles.chevronIcon} />
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  transactionContainer: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    backgroundColor: color.white,
    borderRadius: 8,
    elevation: 1,
    marginBottom: 12,
    marginHorizontal: 16,
  },
  transactionTextContainer: {
    marginLeft: 12,
    flexDirection: "row",
    alignItems: "center",
  },
  transactionAmount: {
    fontSize: 30,
    fontWeight: "bold",
    color: color.mediumBlack,
    lineHeight: 40,
  },
  transactionDescription: {
    color: color.black06,
    marginLeft: 12,
  },
  chevronIcon: {
    height: 12,
    width: 12,
  },
  chevron: {
    position: "absolute",
    right: 16,
  },
});

export default TransactionCard;
